/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EscalationRecord
 */
export interface EscalationRecord {
    /**
     * 
     * @type {Date}
     * @memberof EscalationRecord
     */
    escalatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof EscalationRecord
     */
    escalatedFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof EscalationRecord
     */
    escalatedTo?: string;
    /**
     * 
     * @type {string}
     * @memberof EscalationRecord
     */
    escalatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof EscalationRecord
     */
    escalationReason?: string;
    /**
     * 
     * @type {string}
     * @memberof EscalationRecord
     */
    escalationLevel?: string;
}

/**
 * Check if a given object implements the EscalationRecord interface.
 */
export function instanceOfEscalationRecord(value: object): value is EscalationRecord {
    return true;
}

export function EscalationRecordFromJSON(json: any): EscalationRecord {
    return EscalationRecordFromJSONTyped(json, false);
}

export function EscalationRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): EscalationRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'escalatedAt': json['escalatedAt'] == null ? undefined : (new Date(json['escalatedAt'])),
        'escalatedFrom': json['escalatedFrom'] == null ? undefined : json['escalatedFrom'],
        'escalatedTo': json['escalatedTo'] == null ? undefined : json['escalatedTo'],
        'escalatedBy': json['escalatedBy'] == null ? undefined : json['escalatedBy'],
        'escalationReason': json['escalationReason'] == null ? undefined : json['escalationReason'],
        'escalationLevel': json['escalationLevel'] == null ? undefined : json['escalationLevel'],
    };
}

export function EscalationRecordToJSON(json: any): EscalationRecord {
    return EscalationRecordToJSONTyped(json, false);
}

export function EscalationRecordToJSONTyped(value?: EscalationRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'escalatedAt': value['escalatedAt'] == null ? undefined : ((value['escalatedAt']).toISOString()),
        'escalatedFrom': value['escalatedFrom'],
        'escalatedTo': value['escalatedTo'],
        'escalatedBy': value['escalatedBy'],
        'escalationReason': value['escalationReason'],
        'escalationLevel': value['escalationLevel'],
    };
}

